import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { ModalController, IonToggle, IonicModule } from '@ionic/angular';
import { Store, select } from '@ngrx/store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import { AsyncPipe } from '@angular/common';
import { AppState } from 'src/app/app.module';
import { settingsFeature } from 'src/app/ngrx/settings/settings.feature';
import { SettingsActions } from 'src/app/ngrx/settings/settings.actions';
import { IPushChannel } from 'src/app/ngrx/settings/settings.models';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.page.html',
  styleUrls: ['./wizard.page.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [IonicModule, AsyncPipe, TranslatePipe],
})
export class WizardPage implements OnInit {
  modalController = inject(ModalController);
  private store = inject<Store<AppState>>(Store);
  translate = inject(TranslateService);

  @ViewChild('swiper', { static: false }) slides!: ElementRef;
  public languages: { lang: string; translationKey: string }[] = [];
  public push$: Observable<boolean>;
  public pushChannels$: Observable<{ [K in IPushChannel]?: boolean }>;
  public isEnd = new BehaviorSubject(false);

  constructor() {
    this.push$ = this.store.pipe(select(settingsFeature.selectPushEnabled));
    this.pushChannels$ = this.store.pipe(select(settingsFeature.selectPushChannels));
  }

  ngOnInit() {
    this.languages = this.translate.getLangs().map((value: string) => ({
      lang: value,
      translationKey: `settings.lang.${value}`
    }));
  }

  public slideChanged() {
    const swiper = this.slides?.nativeElement?.swiper;
    this.isEnd.next(Boolean(swiper?.isEnd));
  }

  public next() {
    this.slides?.nativeElement?.swiper?.slideNext?.();
  }

  public togglePush(event: IonToggle): void {
    this.store.dispatch(SettingsActions.togglePush({ enabled: event.checked }));
  }

  public togglePushChannel(event: IonToggle): void {
    const channel: IPushChannel = event.name as IPushChannel;
    this.store.dispatch(SettingsActions.togglePushChannel({ channel, enabled: event.checked }));
  }

  public selectLanguage(event: any) {
    const language = event.detail.value;
    this.store.dispatch(SettingsActions.changeLanguage({ language }));
  }

  public done() {
    Preferences.set({ key: 'wizardCompleted', value: 'true' });
    this.modalController.dismiss();
  }
}
